import { BackgroundWrapper } from "./Layout";
import DesktopRouter from "../../desktop/Router";
import React from "react";
import styled from "styled-components";

export const Content = () => {
	return (
		<Container>
			<BackgroundWrapper>
				<DesktopRouter></DesktopRouter>
			</BackgroundWrapper>
		</Container>
	);
};

const Container = styled.div`
	min-height: 300px;
`;
